import { render, staticRenderFns } from "./aboutUsIndex.vue?vue&type=template&id=33b3e429"
var script = {}
import style0 from "./aboutUsIndex.vue?vue&type=style&index=0&id=33b3e429&prod&lang=css"
import style1 from "./aboutUsIndex.vue?vue&type=style&index=1&id=33b3e429&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports